import React from 'react';
import { Box, IconButton, Typography, Avatar, Divider, useMediaQuery, useTheme } from '@mui/material';
import { Close } from '@mui/icons-material';

function DrawerHeader({ avatar, title, subtitle, onClose, overflowMenu }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const avatarSize = isMobile ? 48 : 56;

  return (
    <Box sx={{ flexShrink: 0, bgcolor: 'background.paper', position: 'sticky', top: 0, zIndex: 1 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          px: 2,
          py: 2,
        }}
      >
        {avatar && (
          <Avatar
            sx={{
              width: avatarSize,
              height: avatarSize,
              fontSize: avatarSize * 0.4,
              fontWeight: 700,
              flexShrink: 0,
              ...avatar.sx,
            }}
          >
            {avatar.children}
          </Avatar>
        )}

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="subtitle1"
            fontWeight="700"
            sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>

        {overflowMenu && (
          <Box sx={{ flexShrink: 0 }}>
            {typeof overflowMenu === 'function' ? overflowMenu() : overflowMenu}
          </Box>
        )}

        <IconButton size="small" onClick={onClose} aria-label="Close drawer" sx={{ flexShrink: 0 }}>
          <Close />
        </IconButton>
      </Box>
      <Divider />
    </Box>
  );
}

export default DrawerHeader;
